//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/SIM.js";
import "../no/Builder.js";
let d=[[[0,"Dump",1,0],[0,"Output",1,0],[0,"OutputFile",1,0],[0,"PartFolder",1,0]],[[["partFolder","outputFile"],"ExportGeometryInformation",{},2,0]],[]];
SPLM.SIM.SmkDebugBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SIM.SmkDebugBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.SIM.SmkDebugBuilder.DumpType = Object.freeze({
    "None" : "None", "MachineKit" : "MachineKit"});

SPLM.SIM.SmkDebugBuilder.OutputType = Object.freeze({
    "Syslog" : "Syslog", "ListingWindow" : "ListingWindow", "Autotest" : "Autotest", "ToFile" : "ToFile"});

export default SPLM;